import React, { useState } from "react";
import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";
import propertyData from "./property.json";
import {
  FaBaby,
  FaChair,
  FaParking,
  FaRegBuilding,
  FaSuitcase,
  FaTree,
  FaTv,
  FaWater,
  FaWifi,
  FaFire,
  FaTemperatureHigh,
  FaBreadSlice,
  FaIcicles,
} from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";

export default function AnnexInformation() {
  const toggleReadMore = () => {
    var readMoreContent = document.getElementById("readMoreContent");
    var readMoreButton = document.getElementById("readMoreButton");

    if (
      readMoreContent.style.display === "none" ||
      readMoreContent.style.display === ""
    ) {
      readMoreContent.style.display = "block";
      readMoreButton.innerHTML = "Read Less...";
    } else {
      readMoreContent.style.display = "none";
      readMoreButton.innerHTML = "Read More...";
    }
  };

  const [showLocationDetails, setShowLocationDetails] = useState(false);

  const toggleLocationDetails = () => {
    setShowLocationDetails(!showLocationDetails);
  };

  return (
    <>
      <Row>
        <Row>
          <Col>
            <hr />
            <h5 className="mb-2">Information about the property</h5>
            <Container>
              <p>
                This sweet little place is tucked away in the back of 
                Ginny and Robs' garden. It’s an ideal location for visitors travelling 
                solo, or in small numbers
              </p>
            </Container>
            <div id="readMoreContent">
              <Container>
                <p>
                  It consists of one twin bedroom, a shower room, and a main 
                  living room with a double bed, and a kitchenette. Cooking facilities 
                  include toaster, kettle, two hot ring stove, small oven, microwave, 
                  sink and fridge with tiny freezer. It is bijou but charming, clean and 
                  comfortable. Unfortunately, dogs cannot stay as we have two of our own 
                  called Pickle and Martha, who are very friendly and welcoming.
                </p>
                <p>
                  One of the additional benefits to staying at Dinerth cottage is 
                  the access to our lovely garden, sheltered pavilion, sun chairs and 
                  private access to the nature reserve Bryn Euryn through our back gate. 
                  From the top of this hill is a stunning 360° view of the area.
                </p>
                <p>
                  It is comfortable, self catering and convenient for anyone who wishes 
                  to attend nearby shows, concerts or rugby games, close to Llandudno, 
                  Betws y Coed, Llanberis and Snowdonia for site seeing, outdoor pursuits, 
                  zip wire, bounce below, surfing, walking, running, mountain climbing, cycling, swimming and much more.
                </p>
                <p>
                  The village of Rhos on Sea with its cafés, pubs, restaurants and shop, 
                  the harbour and beach are 5 minutes drive away. Nearest shop for general supplies 
                  is a 15 minute walk or 2 minute drive away end of our road.
                </p>
                <p>
                  Anyone interested in art classes can also book directly with us <a href="https://ginnyhelsen.co.uk/lessons-and-workshops">here</a>.
                </p>
              </Container>
            </div>
            <Button
              id="readMoreButton"
              variant=""
              className="mb-4 fw-bold"
              onClick={() => toggleReadMore()}
            >
              Read More...
            </Button>
          </Col>
        </Row>
        <hr />

        <Row className="my-4">
          <h5>Amenities:</h5>
          <Col md={4}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaWater className="icon" /> Public or shared beach access
              </ListGroup.Item>
              <ListGroup.Item>
                <FaParking className="icon" /> Free parking on premises
              </ListGroup.Item>
              <ListGroup.Item>
                <FaWifi className="icon" /> Dryer
              </ListGroup.Item>
              <ListGroup.Item>
                <FaTree className="icon" /> Private back garden – Fully fenced
              </ListGroup.Item>
              <ListGroup.Item>
                <FaBaby className="icon" /> Travel cot – available upon request
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md={4}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaWifi className="icon" /> Wifi
              </ListGroup.Item>
              <ListGroup.Item>
                <FaTv className="icon" /> 45" HDTV with Netflix
              </ListGroup.Item>
              <ListGroup.Item>
                <FaRegBuilding className="icon" /> Shared patio or balcony
              </ListGroup.Item>
              <ListGroup.Item>
                <FaSuitcase className="icon" /> Luggage drop-off allowed
              </ListGroup.Item>
              <ListGroup.Item>
                <FaChair className="icon" /> Booster seat high chair – available
                upon request
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md={4}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaBreadSlice className="icon" /> Toaster
              </ListGroup.Item>
              <ListGroup.Item>
                <FaWater className="icon" /> Kettle
              </ListGroup.Item>
              <ListGroup.Item>
                <FaFire className="icon" /> Stove
              </ListGroup.Item>
              <ListGroup.Item>
                <FaTemperatureHigh className="icon" /> Oven
              </ListGroup.Item>
              <ListGroup.Item>
                <FaIcicles className="icon" /> Fridge and Freezer
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>
        <hr />
        <h5>Location</h5>
        <p className="mt-3">
          <MdLocationPin size={28}></MdLocationPin>
          {propertyData.location}
        </p>
        <div className="iFrame" id="map">
          <iframe
            className="my-3"
            title="maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2384.2587420657424!2d-3.763091524138011!3d53.302812277981026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48651f966639b3b9%3A0xe012b09117b4652f!2sDinerth%20Rd%2C%20Rhos%20on%20Sea%2C%20Colwyn%20Bay!5e0!3m2!1sen!2suk!4v1698335479973!5m2!1sen!2suk"
            width="100%"
            height="450"
            allowFullScreen={false}
            loading="lazy"
          ></iframe>
          <Row className="my-4">
            <Col>
              <h5 className="font-weight-bold">About the Location:</h5>
              <p>Rhos on Sea, Wales, United Kingdom</p>
              <Container>
                <p>
                  Our home backs onto the Bryn Euryn nature reserve, within
                  minutes you can be walking in woodland and seeing 360' views
                  over to Snowdon, Anglesey, and even Liverpool. Rhos on Sea
                  village is five minutes away by car where there are plenty of
                  cafe's pubs and takeaways. The holiday towns of Llandudno and
                  Colwyn Bay are a 10-minute trip with Shops, Cafes, Cinema,
                  Live Bands, Concerts, Rugby. 30 minutes from Surf Snowdonia,
                  Climbing, Zip Wire, Bounce Below, Snowdonia National Park.
                </p>
              </Container>
              {showLocationDetails && (
                <div id="readMoreLocation">
                  <Container>
                    <p>Getting around</p>
                    <p>
                      There is a bus stop within 100m of our property which will
                      take you to all areas of the coast. There are also many
                      bike and walking routes nearby.
                    </p>
                    <p>
                      Although you have your own place, it dwells within a
                      shared garden belonging to Ginny and Rob. It is quite a large
                      and wild garden, with different areas for you to sit and
                      relax, it also backs directly on to a nature reserve of
                      woodland and pasture at the top. Bryn Euryn is a beautiful
                      131m (430ft) hill with a 360 view at the top.
                    </p>
                  </Container>
                </div>
              )}
              <Button
                id="locationDetailsButton"
                variant=""
                className="mb-4 fw-bold"
                onClick={() => toggleLocationDetails()}
              >
                {showLocationDetails ? "Read Less..." : "Read More..."}
              </Button>
            </Col>
          </Row>
        </div>
      </Row>
    </>
  );
}
